<template>
  <div class="wx-open-message-configure-pub-query"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="pubTemplate">
      <div class="body">
        <div class="body-cont">
          <DataGrid size="mini"
                    border="inner"
                    height="auto"
                    highlight-current-row
                    highlight-hover-row
                    show-overflow="title"
                    show-header-overflow="title"
                    :data="pubTemplate.items">
            <DataGridColumn title="模版标题ID"
                            field="tid"
                            min-width="100"
                            align="center"></DataGridColumn>
            <DataGridColumn title="模版标题"
                            field="title"
                            min-width="160"></DataGridColumn>
            <DataGridColumn title="模版类型"
                            field="type"
                            min-width="100"
                            align="center">
              <template #default="{row}">
                <span>{{row.type | tplType}}</span>
              </template>
            </DataGridColumn>
            <DataGridColumn title="所属类目"
                            field="categoryId"
                            min-width="100"
                            align="center">
              <template #default="{row}">
                <span>{{row.categoryId | categoryType(categories)}}</span>
              </template>
            </DataGridColumn>
            <DataGridColumn title="操作"
                            width="100"
                            align="center"
                            fixed="right">
              <template #default="{row}">
                <WxOpenMessageConfigurePubDetail :item="row">
                  <template #default="{show}">
                    <el-button size="mini"
                               type="text"
                               @click="show">查看详情</el-button>
                  </template>
                </WxOpenMessageConfigurePubDetail>
              </template>
            </DataGridColumn>
          </DataGrid>
        </div>
      </div>
      <div class="footer">
        <el-pagination small
                       :page-size.sync="query.limit"
                       :current-page.sync="query.start"
                       :total="pubTemplate.count"
                       layout="prev, pager, next, ->, total"
                       @size-change="loadPubTemplate"
                       @current-change="loadPubTemplate"></el-pagination>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>模板数据加载失败</div>
        <el-button type="text"
                   @click="loadPubTemplate">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import DataGrid from '../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../elements/DataGridColumn'
import WxOpenMessageConfigurePubDetail from './detail'
import Hint from '../../../../../../../../elements/Hint'
export default {
  name: 'WxOpenMessageConfigurePubQuery',
  components: {
    DataGrid,
    DataGridColumn,
    WxOpenMessageConfigurePubDetail,
    Hint
  },
  props: {
    categories: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      pubTemplate: null,
      query: {
        start: 1,
        limit: 10
      }
    }
  },
  filters: {
    tplType (type) {
      switch (type) {
        case 2:
          return '一次性订阅'
        case 3:
          return '长期订阅'
        default:
          return type
      }
    },
    categoryType (type, categories) {
      const categoryType = `${type}`
      const category = (categories || []).find(category => `${category.id}` === categoryType)
      if (category) {
        return category.name
      } else {
        return categoryType
      }
    }
  },
  methods: {
    loadPubTemplate () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/message/wx/open/pubTemplate',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          ids: this.categories.map(category => category.id)
        }, this.query), {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.pubTemplate = response.data['pubTemplate'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadPubTemplate()
  }
}
</script>

<style lang="scss">
  .wx-open-message-configure-pub-query {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .body {
      flex: auto;
      position: relative;
      & > .body-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .vxe-table {
          &:after {
            display: none;
          }
          .vxe-table--header-wrapper {
            .vxe-table--header {
              .vxe-header--row {
                background-color: #f9f9fa;
              }
            }
          }
        }
      }
    }
    & > .footer {
      flex: none;
      .el-pagination {
        padding: 8px 15px;
        border-top: 1px solid rgba(0,0,0,.03);
        .el-pagination__rightwrapper {
          .el-pagination__total {
            font-size: 12px;
          }
        }
        .btn-prev,
        .btn-next {
          padding: 0 6px;
          background-color: transparent;
        }
        .el-pager {
          & > li {
            font-weight: normal;
            background-color: transparent;
          }
        }
      }
    }
  }
</style>
